/*  MUI  */
import { Typography } from '@mui/material';

/*  Shared  */
import { Token } from 'application/Shared/Requests';

/* Hooks */
import { getUserTheme } from 'hooks/dataAccess/User/userTheme';

/*  React  */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

/*  Components  */
import { IntegrationWrapper } from './Components/IntegrationWrapper';

/* Constants */
import IntegrationScriptFilename from './Constants/IntegrationScriptsFilename.json';

/* Helpers */
import { getScript } from './Helpers/utils';

class API extends Component {
    constructor(props) {
        super(props);
        this.state = {
            deploymentSteps: [],
            hasToken: false
        };

        /* requests */
        this.Token = new Token();
    }

    componentDidMount() {
        this.load();
    }

    componentWillUnmount() {
        this.unload();
    }

    load = async () => {
        const partnerToken = await this.Token.getToken();

        if (partnerToken) {
            this.setState({ hasToken: true });
            this.setDeploymentSteps(partnerToken);
        }
    };

    unload = () => {
        this.Token.cancel();
    };

    setDeploymentSteps = async (token) => {
        const { t } = this.props;

        const filenamePath = IntegrationScriptFilename.kaseyaVSAScript;

        const filename = filenamePath.slice(filenamePath.lastIndexOf('/') + 1);

        const scriptCopyValue = await getScript({
            filename: filenamePath,
            token
        });

        const deploymentSteps = [
            {
                component: (
                    <Typography variant="h4">
                        {t('Integrations.setup_process')}
                    </Typography>
                ),
                step: false
            },
            {
                component: t('Integrations.KaseyaVSA.step1'),
                copyValue: scriptCopyValue,
                download: filename,
                step: true
            },
            {
                component: t('Integrations.KaseyaVSA.step2'),
                step: true
            },
            {
                component: t('Integrations.KaseyaVSA.step3'),
                step: true
            },
            {
                component: t('Integrations.KaseyaVSA.step4'),
                step: true
            }
        ];

        this.setState({ deploymentSteps });
    };

    render() {
        const { onboarding = false, session, t } = this.props;
        const { deploymentSteps, hasToken } = this.state;
        const userTheme = getUserTheme(session?.user?.theme);

        return (
            <IntegrationWrapper
                hasToken={hasToken}
                deploymentSteps={deploymentSteps}
                headerTitle={t('Integrations.KaseyaVSA.title')}
                img={`/images/${userTheme}/integrations/kaseya_vsa.png`}
                imgWidth="200px"
                onboarding={onboarding}
            />
        );
    }
}

export default withTranslation()(API);
